<template>
   <div class="form-group">
        <label for="hrt_multi_select">{{ label_field }}</label>
        <select name="hrt_multi_select" v-model="last_item_selected" class="form-control" @change="addToOptionsSelected($event)">
            <option v-for="item in options" v-bind:key="item.id" :value="item.id">{{item.value}}</option>
        </select>
        <div>            
            <div v-for="item in options_selected_field" v-bind:key="item.id">
                <input type="hidden" :name="name_field" :value="item.id">
                <div class="mt-2">
                    <span class="ml-2 cursor-pointer" @click="removeItem(item)">
                        <i class="fa fa-trash text-danger"></i>
                    </span>
                    <span>&nbsp;{{item.value}}</span>
                </div></div>
            </div>
        </div>
   </div>
</template>
<script>
export default {  
    mounted() {
        this.last_item_selected = null
        if (this.options_selected == null){
            this.options_selected_field = [];
        } else {
            this.options_selected_field = this.options_selected;
        }        
    },
    data () {
        return {
            last_item_selected: null,
            options_selected_field: null
        }
    },
    methods: {
        addToOptionsSelected() {
            
            var itemSelected = this.last_item_selected; 
            var isObjectExists = this.options_selected_field.find(item => item.id === itemSelected);
            
            if (!isObjectExists) {
                var itemFound = this.options.find(item => item.id === itemSelected);
                this.options_selected_field.push(itemFound);                
            } 
            
            this.last_item_selected = null;
        },
        removeItem(itemSelected){
            this.options_selected_field = this.options_selected_field.filter(item => item.id !== itemSelected.id);
        }
    },
    props: {
        options: {
            type: Array,
            required: true
        },
        options_selected: {
            type: Array,
            required: false,
            default: null
        },
        label_field: {
            type: String,
            default: null
        },        
        name_field: {
            type: String,
            default: null
        }
    }
}
</script>